<template>
    <el-drawer
        :title="label"
        :visible.sync="showBox"
        direction="rtl"
        size="300px"
        :append-to-body="true"
        :before-close="close">
        <div class="panel form" v-if="myFile.url == undefined && resources.length > 0 ">
            <file-preview v-for="(item, i) in resources" :key="i" :allow-preview="true" :allow-download="true"
                width="200" height="120" :url="item.url" @play="$emit('play', item.url)"></file-preview>
        </div>
        <div class="panel form" v-if="myFile.url != undefined">
            <file-preview  :allow-preview="true" :allow-download="true"
                width="200" height="120" :url="myFile.url" @play="$emit('play', myFile.url)"></file-preview>
        </div>
        <el-upload
            class="upload-demo"
            action=""
            accept="image/*,text/plain,application/zip,application/rar,application/vnd.ms-powerpoint,application/msword,application/vnd.ms-excel,application/pdf"
            :before-upload="uploadattachment"
            multiple
            >
            <el-button size="small"  type="primary" style="margin-left:99px;">上传文件</el-button>
            <div slot="tip" class="el-upload__tip">只能上传压缩文件或者Office、Pdf文档，且不超过10M。</div>
        </el-upload>
        <span  class="fx fx-center">
            <!-- <el-button type="primary" @click="sub()">确 定</el-button> -->
            <el-button @click="close()">关 闭</el-button>
        </span>
    </el-drawer>
</template>

<style scoped>
  .excel_opt {
        width: 130px;
        height: 130px;
        border-radius: 10px;
        border: 1px solid var(--primary);
        margin-left: 67px;
        margin-bottom: 15px;
    }
    .excel_opt .iconfont{
        color: var(--primary);
        font-size: 50px;
    }
    i.el-icon-arrow-right {
        font-size: 50px;
        font-weight: bold;
        margin: 0 20px;
    }
</style>


<script>


    export default {
        props: [
            "label",
            "resources",
            "showBox",
        ],
        data() {
            return {
                myFile:{},
            }
        },


        methods: {
            close() {
                this.myFile={};
                this.$emit("close");
            },
            uploadattachment(file) {
                var fileSize = (file.size / 1024).toFixed(2);
                if (file.size / 1048576 > 10) {
                    this.$showError("禁止上传超过10M大小文件");
                    return;
                } else {
                    this.$uploadQiniu(file, "lessontask/", {success: (fileData) => {
                            this.myFile = Object.assign({}, this.myFile, {url: fileData.url,fileSize:fileSize});
                            //this.myFile = fileData;
                            this.sub();
                        }
                    })
                }
                return false;
            },
            sub() {
                if(this.myFile.url == undefined){
                    this.$showError("请上传文件");
                    return;
                }
                this.resources[0].url = this.myFile.url;
                this.resources[0].fileSize = this.myFile.fileSize;
                this.resources[0].useEnable = true;
                this.$ajaxPost("/mediaResource/saveResource",{mediaResource:this.resources[0]}, data => {
                    this.$showSuccess("上传成功");
                    this.$emit("close");
                })
            },
        },
        created() {
        },

    }
</script>
